// @ts-nocheck



import { createAction, createSlice } from '@reduxjs/toolkit';







import { detailedDefectiveStatementApi } from '../lib/api';

export const CLEAR_DETAILED_DEFECTIVE_STATEMENT =
'vehicles/detailed-defective-statement/clear';
export const SET_DETAILED_DEFECTIVE_STATEMENT =
'vehicles/detailed-defective-statement/set';

const initialState = null;

const clearDetailedDefectiveStatement = createAction(
  CLEAR_DETAILED_DEFECTIVE_STATEMENT
);
const setDetailedDefectiveStatementAction = createAction(
  SET_DETAILED_DEFECTIVE_STATEMENT
);

const detailedDefectiveStatementSlice = createSlice({
  name: 'detailedDefectiveStatement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(setDetailedDefectiveStatementAction, (_, { payload }) => payload).
    addCase(clearDetailedDefectiveStatement, () => initialState);
  }
});

export const detailedDefectiveStatementActions = {
  clear: clearDetailedDefectiveStatement,
  set: setDetailedDefectiveStatementAction
};

export const clear = () => (dispatch) =>
dispatch(detailedDefectiveStatementActions.clear());

export const setDetailedDefectiveStatement = (
detailedDefectiveStatement) =>
async (dispatch) => {
  dispatch(
    detailedDefectiveStatementActions.set({ ...detailedDefectiveStatement })
  );
};

export const saveOperations = (
operations) =>
async (
dispatch,
getState) =>
{
  const detailedDefectiveStatement = await detailedDefectiveStatementApi.updateDetailedDefectiveStatement(
    {
      ...getState().detailedDefectiveStatement,
      operations
    }
  );
  dispatch(
    detailedDefectiveStatementActions.set({ ...detailedDefectiveStatement })
  );
};

export const saveParts = (
parts) =>
async (
dispatch,
getState) =>
{
  const detailedDefectiveStatement = await detailedDefectiveStatementApi.updateDetailedDefectiveStatement(
    {
      ...getState().detailedDefectiveStatement,
      parts
    }
  );
  dispatch(
    detailedDefectiveStatementActions.set({ ...detailedDefectiveStatement })
  );
};

export const saveDetailedDefectiveStatement = (
detailedDefectiveStatement) =>
async (dispatch) => {
  const updated = await detailedDefectiveStatementApi.updateDetailedDefectiveStatement(
    detailedDefectiveStatement
  );
  dispatch(detailedDefectiveStatementActions.set({ ...updated }));
};

export default detailedDefectiveStatementSlice.reducer;
